import { Typography } from 'antd';
import React from 'react';
import { formatCurrency } from '~/utils/currency';
import i18n from '~/i18n';
import './style.css';
import { Order } from '@restaurant/api';

const { Title, Text } = Typography;

const TotalSection = ({ order }: { order: Order }) => {
  return (
    <div
      className="order-total-section px-4 py-2"
      style={{ boxShadow: '0px -35px 40px 12px white' }}
    >
      <div className="mb-2">
        <div className="flex justify-between items-center">
          <Text>Subtotal</Text>
          <Text>{formatCurrency(order.subtotalPrice || 0)}</Text>
        </div>
        <div className="flex justify-between items-center">
          <Text>Tax</Text>
          <Text>
            {formatCurrency(order.tax?.isApplied ? order.tax.amount : 0)}
          </Text>
        </div>
      </div>
      <div className="flex justify-between items-center">
        <Title level={5} style={{ margin: 0 }}>
          {i18n.t('order_total_price')}
        </Title>
        <Title level={5} style={{ margin: 0 }}>
          {formatCurrency(order.totalPrice || 0)}
        </Title>
      </div>
    </div>
  );
};

export default TotalSection;
